import { Themed } from 'theme-ui'
import { Button } from '../../elements/trustyle-button'
import DropDown from '../../elements/drop-down'
import { GridLayout } from '@uswitch/ev-core/react'

const { Column } = GridLayout

const DropdownFilter = ({ filter, setOptionValue }) => (
  <Column s={1 / 1} m={4 / 12} l={4 / 12} key={filter.label} sx={{ padding: 0 }}>
    <label for={filter.label}>{filter.label}</label>
    <DropDown
      name={filter.label}
      onBlur={() => {}}
      onChange={o => {
        const option = JSON.parse(o)
        setOptionValue(filter, option, option.value)
      }}
      options={filter.options.map(option => ({
        text: option.label,
        value: JSON.stringify(option),
      }))}
      value={JSON.stringify(filter.options.find(op => op.value))}
      sx={{ borderColor: 'grey-20', fontSize: 'xs' }}
    />
  </Column>
)

const CheckboxFilter = ({ filter, setOptionValue }) => (
  <div key={filter.label}>
    {filter.label}
    <For each='option' of={filter.options}>
      <label sx={{ display: 'block', marginY: 'xs' }} key={option.label}>
        <input
          type='checkbox'
          defaultChecked={option.value}
          onChange={e => setOptionValue(filter, option, e.target.checked)}
          sx={{
            marginRight: 'xs',
          }}
        />
        {option.label}
      </label>
    </For>
  </div>
)

const Filter = ({ filterBy, setFilterBy, handleFilterClick, setFilterOpen }) => {
  const setOptionValue = (filter, option, value) => {
    const optionIndex = filter.options.indexOf(option)
    const checkboxOptions = [
      ...filter.options.slice(0, optionIndex),
      { label: option.label, value },
      ...filter.options.slice(optionIndex + 1),
    ]
    const dropdownOptions = filter.options.map(op => ({
      ...op,
      value: op.label === option.label,
    }))
    const newFilter = {
      label: filter.label,
      type: filter.type,
      options: filter.type === 'dropdown' ? dropdownOptions : checkboxOptions,
    }
    const filterIndex = filterBy.indexOf(filter)
    const newFilterBy = [
      ...filterBy.slice(0, filterIndex),
      newFilter,
      ...filterBy.slice(filterIndex + 1),
    ]
    setFilterBy(newFilterBy)
  }

  return (
    <div sx={{ marginY: 0, padding: 'md', backgroundColor: 'grey-05', borderRadius: 3 }}>
      <For each='filter' of={filterBy}>
        <Choose>
          <When condition={filter.type === 'dropdown'}>
            <DropdownFilter filter={filter} setOptionValue={setOptionValue} />
          </When>
          <Otherwise>
            <CheckboxFilter filter={filter} setOptionValue={setOptionValue} />
          </Otherwise>
        </Choose>
        <Themed.hr />
      </For>
      <div sx={{ textAlign: 'right' }}>
        <Button variant='secondary' onClick={() => setFilterOpen(false)}>
          Close
        </Button>
        <Button variant='primary' sx={{ marginLeft: 'sm' }} onClick={handleFilterClick}>
          Update results
        </Button>
      </div>
    </div>
  )
}

export default Filter
